<template>
  <entity-select-dialog
      ref="entitySelectDialog"
      :search="search"
      :items="items"
      :loading="loading">

    <template v-slot:listItem="props">
      <device-list-item :item="props.item"
                        :row-click-enabled="true"
                        :showActions="false"/>

    </template>
  </entity-select-dialog>
</template>

<script>
import DevicesService from '@/services/DevicesService';
import DeviceListItem from '@/views/devices/DeviceListItem';
import EntitySelectDialog from '@/components/entity-crud/EntitySelectDialog';

export default {
  name: 'DeviceSelectDialog',
  components: { EntitySelectDialog, DeviceListItem },

  data: () => ({
    items: [],
    loading: false,
  }),

  methods: {

    selectedEntity(device) {
      this.$emit('selected', device);
      this.close();
    },

    show() {
      this.$refs.entitySelectDialog.show();

    },

    close() {
      this.$refs.entitySelectDialog.close();
    },

    mapToItem(device){
      return {
        device: device,
        rowClick: () => {
          this.selectedEntity(device);
        },
      };
    },
    search(searchTerm) {
      if (!searchTerm) {
        searchTerm = null;
      }

      this.items = [];
      this.loading = true;
      DevicesService.findDevicesByNameOrIdentification(searchTerm).then(result => {
        this.items = result.data.map(this.mapToItem);
      }).catch(err => {
        console.log(err);
      }).finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped>

</style>
